import { Box, Typography } from '@mui/material';
import apiManagerSystem from 'api/manager-systems';
import { DIALOG_ID } from 'components/Dialog/constant';
import LanguageCC from 'components/Layout/LanguageCC';
import { PATH_ROOT, URL_LANDING_PAGE } from 'constants/api';
import { AppInfo } from 'layouts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { getAccessToken } from 'utils/cookies';
import { setOpenDialogCC } from 'utils/helpers';

export default function Layout() {
    //GLOBAL VARIABLE
    const [globalVariable, setGlobalVariable] = useState({
        isRedirectFromLogin: false
    })

    const navigate = useNavigate();
    const [params, setParams] = useSearchParams();
    const { t } = useTranslation();

    const getVariableSystemConfig = (code) => {
        return apiManagerSystem.getOneConfig(code);
    }

    useEffect(() => {
        if (params.get("provide-service") === "true") {
            setOpenDialogCC({
                id: DIALOG_ID.PROVIDE_SERVICE,
                props: {
                    isLogin: true
                }
            })
            setTimeout(() => {
                params.delete('provide-service');
                setParams(params)
            }, 500)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])

    useEffect(() => {
        const accessToken = getAccessToken();
        if (accessToken) {
            let domain = "/manager-meeting";
            getVariableSystemConfig("DEFAULT_PAGE")
                .then(r => {
                    if (r.data[0]?.code) {
                        switch (r.data[0]?.value) {
                            case "MEETING_NOW":
                                domain = `${PATH_ROOT}/manager-meeting`;
                                break;
                            case "VIDEO_CONFERENCE":
                                domain = `${PATH_ROOT}/call-sip`;
                                break;
                            default:
                                domain = `${PATH_ROOT}/manager-meeting`;
                        }
                    }
                })
                .catch(e => {
                    console.log("ERROR: ", e);
                })
                .finally(() => {
                    if (globalVariable?.isRedirectFromLogin) {
                        navigate(domain);
                    }
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalVariable]);

    return (
        <div className="login-container">
            <div className='drop-down-language'>
                <LanguageCC />
            </div>
            <div className={`main-login ${window.location.pathname === '/register' ? 'layout-register' : ''}`}>
                <Box
                    sx={{
                        display: { xs: 'block', md: 'flex' },
                        justifyContent: 'center',
                        marginRight: { xs: 'unset', md: '5%' },
                        height: { xs: 'auto', xl: 'inherit' }
                    }}
                >
                    <div className='banner-screen' style={{ marginRight: '8%' }}>
                        <AppInfo />
                        <img alt='img-alt' className='img-big-screen' width='890px' src={require('../../assets/img/left_content_1.svg').default}></img>
                        <img alt='img-alt' className={window.location.pathname === '/register' ? 'img-small-screen' : 'img-small-screen'} style={{ marginRight: '8%' }} width='100%' src={require('../../assets/img/left_content_1.svg').default}></img>
                    </div>
                    <div className={window.location.pathname === '/register' ? 'info-right-login' : 'info-right-login'}>
                        <div className='logo_020823' style={window.location.pathname === '/register' ? { marginTop: '1rem' } : { marginTop: '1rem' }}>
                            <a href={URL_LANDING_PAGE}>
                                <img alt='img-alt' className='big-screen' width="53%" src={require('../../assets/img/logo_020823.svg').default}></img>
                                <img alt='img-alt' className='small-screen' width="150px" src={require('../../assets/img/logo_020823.svg').default}></img>
                            </a>
                        </div>
                        <Outlet context={[globalVariable, setGlobalVariable]} />
                    </div>
                </Box>
                <div className="footer-login">
                    <Typography fontWeight={600}>{t('actions.TDCSKH')}</Typography>
                    <Typography>{t('viettel.managing')}</Typography>
                    <Typography>{t('viettel.date')}</Typography>
                </div>
            </div>
        </div>
    );
}
